import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {ProjectFeatureFlag, ReportName} from 'common/report/constants';
import {FeatureRolloutName, FeatureRollouts} from 'common/report/util/feature-sampling';
import {MetricType} from 'common/query-builder/query-block/constants';
import {BookmarkType} from 'common/report/queries/app-api/bookmark-client';

export function canUseMultiAttribution(currentProject?: CurrentProject | ProjectDetails): boolean {
  // Always return true for projects with feature flag enabled
  if (currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttribution)) {
    return true;
  }
  return FeatureRollouts[FeatureRolloutName.MultiAttribution].isEnabled(currentProject);
}

export function canUseMultiAttributionInReport(
  currentProject?: CurrentProject | ProjectDetails,
  reportType?: ReportName | BookmarkType,
): boolean {
  if (
    [
      ReportName.Funnels,
      ReportName.Retention,
      BookmarkType.Funnels,
      BookmarkType.Retention,
      BookmarkType.RetentionFrequency,
    ].includes(reportType)
  ) {
    return FeatureRollouts[FeatureRolloutName.MultiAttributionFunnelsRetention].isEnabled(currentProject);
  }
  return canUseMultiAttribution(currentProject);
}

export function canUseCountUsersOnce(
  currentProject?: CurrentProject | ProjectDetails,
  reportType?: MetricType | BookmarkType,
): boolean {
  if (
    [
      MetricType.Funnel,
      MetricType.Retention,
      MetricType.RetentionFrequency,
      BookmarkType.Funnels,
      BookmarkType.Retention,
      BookmarkType.RetentionFrequency,
    ].includes(reportType)
  ) {
    return currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttributionFunnelsRetention);
  }
  return true;
}
